// extracted by mini-css-extract-plugin
export default {"blockPadding":"usePadding_blockPadding__IGKSO","blockPaddingCompact":"usePadding_blockPaddingCompact__dCAuC"};